import React from "react";
import "./DashboardLink.scss";
import { useHistory } from "react-router-dom";
import { faro } from "@grafana/faro-react";
import { Button } from "@pav/pav-products-design-system";

const DashboardLink = ({ text, icon, link }) => {
  const history = useHistory();
  const transactionClick = () => {
    history.push(link);
    faro.api.pushEvent(
      `User clicked to ${link
        .toString()
        .replace("/", "")
        .replace(/[A-Z]/g, (x) => ` ${x.toLowerCase()}`)}`,
    );
  };

  return (
    <Button
      fullWidth
      buttonType={text === "Deposit Funds" ? "primary" : "secondary"}
      startIcon={<img alt={text} src={icon} />}
      onClick={transactionClick}
    >
      {text}
    </Button>
  );
};

export default DashboardLink;
